<template>
  <div style="height: inherit;">
    <header-view :image="image"></header-view>
    <div style="position: relative; width: 100%; min-height: 100%; height: 100%;">
      <div v-if="view == 'form'" style="height: auto;">
        <contact-form @messagesend='changeView($event)' style="min-height: 69%; width: inherit; min-height: 69%; margin: 0; overflow-y: auto; box-sizing: border-box;"></contact-form>
      </div>
      <div v-else style="height: auto;">
        <contact-confirmation style="min-height: 44vh; margin-top: 5%; margin-bottom: 23vh;"></contact-confirmation>
      </div>
      <footer-view style="position: relative; bottom: 0;"></footer-view>
    </div>
  </div>
</template>

<script>
import HeaderView from './../../components/design/HeaderDesign.vue'
import ContactForm from './../../components/contactus/ContactForm.vue'
import ContactConfirmation from './../../components/contactus/ContactConfirmation.vue'
import FooterView from './../../components/footer/FooterView.vue'
export default {
  name: 'ContactUs',
  components: {
    HeaderView,
    ContactForm,
    ContactConfirmation,
    FooterView
  },
  data: function () {
    return {
      view: 'form',
      image: 'cu'
    }
  },
  methods: {
    changeView () {
      this.view = 'confirmation'
    }
  }
}
</script>
